import { useEffect, useState } from "react";
import { api, ApiError } from "../api";
import { Loading, ErrorNote, StatCard } from "../components/ui";
import { TrendLine } from "../components/charts3";
import { PeriodFilters } from "../components/PeriodFilters";
import { useLocations } from "../hooks";
import type { DashboardSummary, Filters } from "../types";

export default function Dashboard() {
  const locations = useLocations();
  const [filters, setFilters] = useState<Filters>({});
  const [data, setData] = useState<DashboardSummary | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.dashboard(filters)
      .then((d) => { setData(d); setError(null); })
      .catch((e: ApiError) => setError(e.message))
      .finally(() => setLoading(false));
  }, [filters]);

  return (
    <div>
      <h1 className="h1">Dashboard</h1>
      <p className="sub">Office presence overview from processed access-card data.</p>
      <PeriodFilters locations={locations} initialMode="month" storageKey="dashboard" onChange={setFilters} />
      {loading && <Loading what="dashboard" />}
      {error && <ErrorNote message={error} />}
      {data && !loading && (
        <>
          <div className="cards" style={{ marginTop: 18 }}>
            <StatCard label="Employees present" value={data.employees_with_presence} />
            <StatCard label="Attendance days" value={data.total_attendance_days} />
            <StatCard label="Total inside time" value={data.total_inside_hhmm} />
            <StatCard label="Avg daily" value={data.avg_daily_hhmm} />
            <StatCard label="Incomplete days" value={data.incomplete_days} />
            <StatCard label="Needs review" value={data.review_days} />
          </div>
          <div className="panel">
            <h2>Daily inside-office hours</h2>
            <TrendLine data={data.daily_trend} xKey="date" kind="area" unit="hours"
                       lines={[{ key: "inside_seconds", name: "Inside hours" }]} />
          </div>
          <div className="panel">
            <h2>Monthly trend</h2>
            <TrendLine data={data.monthly_trend} xKey="month" unit="hours"
                       lines={[{ key: "inside_seconds", name: "Inside hours" }]} />
          </div>
        </>
      )}
    </div>
  );
}
